import { render, staticRenderFns } from "./CompanyTerritories.vue?vue&type=template&id=0420d83a"
import script from "./CompanyTerritories.vue?vue&type=script&lang=ts"
export * from "./CompanyTerritories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports